import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import { AporteDetalle } from "./AporteDetalle"
import history from "../login/history";
import ButtonLink from "../../generico/ButtonLink";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";


const PAGAR_APORTE = 71;

export default class AporteSocio extends Component {


    constructor(props) {
        super(props);
        this.state = {
            listaAportes: [],
            detalles: [],
        };
    }

    componentDidMount() { }

    getColumn() {
        return [
            {
                name: "Integrado",
                selector: row => row.integrado
            },
            {
                name: "Obligación hasta fin de año",
                selector: row => row.obligacionAnho,
                right: true
            },
            {
                name: "Obligación hasta fin de mes",
                selector: row => row.obligacionMes,
                right: true
            },
            {
                name: "Obligación a la fecha",
                selector: row => row.obligacionFecha,
                right: true
            },
            {
                cell: (row) => (
                    <ButtonLink
                        className="btn btn-cu-terciary btn-sm btn-pay"
                        onClick={this.pagarAporte}
                        url={ConfigService.getPathById(PAGAR_APORTE)?.url}>
                        <FontAwesomeIcon icon={faMoneyBill} />  Pagar
                    </ButtonLink>

                ),

            }
        ];
    }
    pagarAporte = (url) => {
        //history.push('/pagoAporte');
        history.push(url);
        window.location.reload();
    }

    render() {

        return (
            <div>
                <div className="form-group">
                    <div className="table-responsive">
                        <DataTable
                            noHeader={true}
                            columns={this.getColumn()}
                            data={this.props.aporte}
                            pagination={false}
                            noDataComponent="no hay registros para mostrar"
                            responsive={true}
                            expandableRows
                            expandableRowsComponent={AporteDetalle}
                            expandableRowsComponentProps={{ detalle: this.props.detalle, cuota: "TODOS" }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
